<template>
  <article v-scroll:reveal="{delay:250}" class="slider">
    <figure 
      v-for="(slide, index) in slides" 
      :key="slide"
      class="slider__image" 
      :class="{ '-active': index === currentSlideIndex }" 
      :style="{ backgroundImage: `url('${slide}')` }" 
    />

    <section class="slider__dots">
      <div 
        v-for="(slide, index) in slides" 
        :key="slide"
        class="slider__dot" 
        :class="{ '-active': index === currentSlideIndex }"
      />
    </section>

    <section class="slider__controls">
      <button class="slider__arrow -left" @click="prevSlide">
        <svg-icon id="arrow" />
      </button>

      <button class="slider__arrow -right" @click="nextSlide">
        <svg-icon id="arrow" />
      </button>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeHeaderSlider',
  data() {
    return {
      currentTimeout: null,
      currentSlideIndex: 0,
      // slides: [
      //   '/images/slider/expression.jpg',
      //   '/images/slider/boreale.jpg',
      //   '/images/slider/complement.jpg',
      //   '/images/slider/granite-club.jpg',
      //   '/images/slider/iceberg.jpg'
      // ]
    }
  },
  computed: {
    slides() {
      return this.$i18n.t('slider')
    },
    currentSlide() {
      return {
        backgroundImage: `url('${this.slides[this.currentSlideIndex]}')`
      }
    }
  },
  mounted() {
    this.nextSlide(0)
  },
  methods: {
    nextSlide(setSlide) {
      if (this.currentTimeout) clearTimeout(this.currentTimeout)

      if (typeof setSlide === 'number') {
        this.currentSlideIndex = setSlide
      } else {
        this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length
      }

      this.currentTimeout = setTimeout(this.nextSlide, 5000)
    },
    prevSlide() {
      if (this.currentTimeout) clearTimeout(this.currentTimeout)
      this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length
      this.currentTimeout = setTimeout(this.nextSlide, 5000)
    },
  }
}
</script>
